import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type UpdateUserRequestBody = ApiRequestBody<typeof endpoints.user, 'put'>;

export const useUpdateUserMutation = () => {
  return useMutation({
    mutationFn: async ({
      id,
      ...body
    }: { id: string } & UpdateUserRequestBody) => {
      const { data } = await fetchClient.PUT(endpoints.user, {
        params: { path: { id } },
        body,
      });
      return data;
    },
    onSettled: (_result, _error, variables) => {
      invalidateQuery(usersQueryKeys.list())();
      invalidateQuery(usersQueryKeys.detail(variables.id))();
      invalidateQuery(usersQueryKeys.current())();
    },
  });
};
